module.exports = __webpack_public_path__ + "static/media/pathways-bg.86584e84.svg";